<template>
  <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M17.5 10.5c0 3.86-3.14 7-7 7s-7-3.14-7-7 3.14-7 7-7 7 3.14 7 7zm4.5 9.962c0-.41-.168-.806-.445-1.082l-4.122-4.123a8.442 8.442 0 0 0 1.49-4.795A8.459 8.459 0 0 0 10.462 2 8.459 8.459 0 0 0 2 10.462a8.459 8.459 0 0 0 8.462 8.461c1.706 0 3.389-.517 4.795-1.49l4.123 4.11c.276.289.673.457 1.082.457A1.55 1.55 0 0 0 22 20.462z"
      fill="#256AB3"
      fill-rule="evenodd"
    />
  </svg>
</template>

<script>
export default {
  name: "Search"
};
</script>

<style scoped></style>
